import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type GroupFilter } from '../types/filters';

// Founder Info is a group filter - clicking it shows child filters in a submenu
export const founderInfoDefinition: FilterDefinition<GroupFilter> = {
  id: FilterId.FOUNDER_INFO,
  name: 'Founder Info',
  type: FilterType.GROUP,
  isVisible: true,
  children: [
    FilterId.FOUNDER_ETHNICITY,
    FilterId.FOUNDER_GENDER,
    FilterId.FOUNDER_COMPANY,
    FilterId.FOUNDER_PREVIOUS_SCHOOL,
  ],
};

export const founderInfoHandler: FilterHandler<GroupFilter> = {
  isActive(_currentFilterState: GroupFilter) {
    // Group filters are never active themselves
    return false;
  },
  isDefault(_currentFilterState: GroupFilter) {
    // Group filters are always in default state
    return true;
  },
  getEffectiveFilter(currentFilterState: GroupFilter) {
    return { ...currentFilterState };
  },
};
